<nz-spin [nzSpinning]="this.isButtonLoading">
  <div>
    <h6 class="my-3">{{ 'itineraries.moveDeleteDays.dragAndDrop' | transloco }}</h6>
  </div>
  <div
    *ngFor="let day of days; let dayIndex = index;">
    <div
      [attr.draggable]="true"
      (dragstart)="onDaysDragStart($event, dayIndex)"
      (dragover)="onDaysDragOver($event)"
      (drop)="onDaysDrop($event, dayIndex)"
      class="group bg-days w-auto h-auto min-h-16 flex justify-between items-center rounded-lg mt-2 ">
      <div class="ps-4 flex items-center">
        <span class="text-lg sm:text-2xl" nz-icon nzType="calendar" nzTheme="outline"></span>
        <h5 class="px-3 cursor-pointer sm:text-xl text-base ">
          {{ getDayLabel(dayIndex, day?.date, day?.destination?.titles || []) }}
        </h5>
      </div>
      <div class="invisible group-hover:visible pe-4 flex items-center">
      <span
        nz-popconfirm
        [nzPopconfirmTitle]="getDeleteConfirmTitle()"
        nzPopconfirmPlacement="top"
        [nzOkText]="'itineraries.modals.delete.ok' | transloco"
        [nzCancelText]="'itineraries.modals.common.cancel' | transloco"
        (nzOnConfirm)="onConfirmDeleteExperiences(dayIndex)"
        (nzOnCancel)="cancel()"
        class="text-lg sm:text-2xl cursor-pointer" nz-icon nzType="delete"
        nzTheme="outline">
      </span>
      </div>
    </div>
  </div>
</nz-spin>
<div *nzModalFooter>
  <button nz-button nzType="default" (click)="handleCancel()">{{ 'itineraries.moveDeleteDays.actions.close' | transloco }}</button>
  <button nz-button nzType="primary" [nzLoading]="this.isButtonLoading" (click)="this.save()">
    {{ 'itineraries.moveDeleteDays.actions.save' | transloco }}
  </button>
</div>
